import React from "react";
import styled from "../../component/commonCard/style.module.css";

// Shared "not available yet" card. Used for IA sections that are genuinely not
// buildable on real data today (no UTM tracking, no device/OS wired into event
// ingestion, no push real-time infra, no geo map library) -- shown with the
// specific gap named, per the product requirement to never fake data or hide
// the gap silently.
const NotAvailableYet = ({ title, reason }) => (
  <div className={styled.chartCard}>
    <div className={styled.chartCardHead}>
      <h3 className={styled.chartTitle}>{title}</h3>
      <span className={styled.asOfTag}>Not available yet</span>
    </div>
    <p className={styled.emptyHint}>{reason}</p>
  </div>
);

export default NotAvailableYet;
